import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAppSelector } from "@/app/hooks";
import { useSessionBootstrap } from "@/features/auth/useSession";

/**
 * Пускает дальше только аутентифицированного пользователя.
 *
 * Пока статус `unknown` — ничего не решаем: сессия ещё восстанавливается
 * по refresh-cookie. Редирект на /login в этот момент выкидывал бы
 * пользователя при каждой перезагрузке страницы.
 */
export function ProtectedRoute() {
  // Восстановление запускается здесь, а не в AppShell: AppShell рендерится
  // уже внутри защищённой ветки, то есть после решения о доступе.
  useSessionBootstrap();
  const status = useAppSelector((state) => state.auth.status);
  const location = useLocation();

  if (status === "unknown") return <SessionBootstrapping />;
  if (status === "anonymous") {
    // Куда шли — запоминаем, чтобы после входа вернуть на то же место,
    // а не на дефолтную доску.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

function SessionBootstrapping() {
  return (
    <div
      className="flex min-h-dvh items-center justify-center text-sm"
      style={{ color: "var(--color-muted)" }}
      role="status"
      aria-live="polite"
    >
      Восстановление сессии…
    </div>
  );
}
